import React from 'react'
import LazyLoad from 'react-lazyload'
import PropTypes from 'prop-types'
import { isMobile } from 'react-device-detect'
import EmptySpace from './EmptySpace';
import FooterStrip from '../media/images/footer_top_strip_small.jpg'
import FooterHeadingImg from '../media/images/footer_title.png'

import coFinancedEUFundsImg from '../media/images/dofinansolwanie_rudolf_pila.png'

const Image = props => {
  const { src, alt } = props
  return (
    <LazyLoad height={100} throttle={200}>
      <img
        className="album-img"
        src={src}
        alt={alt}
      />
    </LazyLoad>
  )
}
const stripImg = (
  <LazyLoad height={100} throttle={300}>
    {
      FooterStrip
    }
  </LazyLoad>
)

const footerHeadingImg = (
  <LazyLoad height={100} throttle={300}>
    {
      FooterHeadingImg
    }
  </LazyLoad>
)

const divStyle = {
  content: '""',
  position: 'absolute',
  display: 'inline-block',
  width: '100%',
  height: '2px',
  background: `url(${stripImg.props.children}) repeat-x top left`,
  left: '0',
  top: '0',
}

const FooterSpanStyles = {
  background: `url(${footerHeadingImg.props.children})`,
  backgroundPosition: 'left bottom',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '86px 10px',
}

const phoneSzczecin = '+48512652213';
const phonePila = '+48731842951';

const Footer = props => {
  const { imgSrc, selectedCity } = props;
  const phoneHref = selectedCity === 'szczecin' ? `tel:${phoneSzczecin}` : `tel:${phonePila}`;

  return (
    <footer>
      <div className="footer_wrapp">
        <span style={divStyle} />
        <div className="container">
          <div
            className={`${isMobile
              ? 'container' : ''}`}
          >
            <EmptySpace />
            <div
              className="col-md-4"
            >
              <div
                className={`${isMobile
                  ? 'center-block mb35' : ''}`}
              >
                <a href="/">
                  <img
                    src={imgSrc}
                    alt="rudolf"
                    title="Żłobek Rudolf - prywatny żłobek"
                    width="158"
                    height="75"
                  />
                </a>
                <EmptySpace />
                <p>
                  <span className="skyblue">
                    <strong>
                      Żłobek Rudolf
                      {' '}
                    </strong>
                  </span>
                  zapewnia szeroką gamę programów
                  <br />
                  edukacyjnych i działań, które są unikalne same w sobie
                </p>
                <ul className="">
                  <li>
                    <div className="plus icon" />
                    Zajęcia plastyczne
                  </li>
                  <li>
                    <div className="plus icon" />
                    Elementy sensoplastyki
                  </li>
                  <li>
                    <div className="plus icon" />
                    Zajęcia umuzykalniające
                  </li>
                  <li>
                    <div className="plus icon" />
                    Zajecia sportowe
                  </li>
                  <li>
                    <div className="plus icon" />
                    Taniec
                  </li>
                </ul>
              </div>
            </div>
            <div className={`${isMobile ? '' : 'mb20'}`} />
            <div className="col-md-4">
              <div
                className={`${isMobile
                  ? '' : 'mb35'}`}
              >
                <h3 className="widgettitle">
                  Skontaktuj się
                  <span style={FooterSpanStyles} />
                </h3>
                <div className="textwidget">
                  <div>
                    <div className="mobile-solid icon" />
                    {selectedCity === 'szczecin' && (
                      <a href={isMobile ? phoneHref : '/kontakt'}>
                        {phoneSzczecin}
                      </a>
                    )}
                    {selectedCity === 'pila' && (
                      <a href={isMobile ? phoneHref : '/kontakt'}>
                        {phonePila}
                      </a>
                    )}

                  </div>


                  <div>
                    <div className="mail icon" />
                    {selectedCity === 'szczecin' && (
                      <a
                        title="zlobek.rudolf@gmail.com"
                        href="mailto:zlobek.rudolf@gmail.com"
                      >
                        zlobek.rudolf@gmail.com
                      </a>
                    )}
                    {selectedCity === 'pila' && (
                      <a
                        title="zlobek.rudolf.pila@gmail.com"
                        href="mailto:zlobek.rudolf.pila@gmail.com"
                      >
                        zlobek.rudolf.pila@gmail.com
                      </a>
                    )}
                  </div>
                  <div>
                    <div className="pin-solid icon" />
                    {selectedCity === 'szczecin' && (
                      <a href="https://goo.gl/maps/RRwdddCYGqz">
                        9 Maja 9i, Pomorzany,
                        <div className="empty_gap_space" />
                        <span />
                        70-136 Szczecin
                      </a>
                    )}
                    {selectedCity === 'pila' && (
                      <a href="https://goo.gl/maps/BMZ5FZKoekNukTsv6?coh=178571&entry=tt">
                        Artura Grottgera 11 u2,
                        <div className="empty_gap_space" />
                        <span />
                        64-920 Piła
                      </a>
                    )}


                  </div>
                </div>
              </div>
            </div>

            {selectedCity === 'pila' && (
              <div className="col-md-4">
                <div
                  className={`${isMobile
                    ? '' : 'mb35'}`}
                >
                  <h3 className="widgettitle">
                    Dofinansowanie Maluch +
                    <span style={FooterSpanStyles} />
                  </h3>
                  <div className="textwidget">
                    <div>
                    <h4><a href="https://www.facebook.com/hashtag/funduszeue" target="_blank" rel="noopener noreferrer" className="hashtags">#FunduszeUE</a></h4>
                    <h4><a href="https://www.facebook.com/hashtag/funduszeeuropejskie/" target="_blank" rel="noopener noreferrer" className="hashtags">#FunduszeEuropejskie</a></h4>
                      <div className="co-financed-wrapper-footer">
                        <a href="/pila/maluch-plus">
                          <Image src={coFinancedEUFundsImg} alt="Dofinansowanie maluch plus" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <div className="container">
          Wszystkie prawa zastrzeżone
          {' '}
          <strong>
            Niepubliczny żłobek Rudolf
          </strong>
          <span>
            ©
          </span>
        </div>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  selectedCity: PropTypes.string.isRequired,
}

export default Footer
